<template lang="pug">
    nav.mobileNavigation.hidden-md-and-up(
        :class="platformClass"
        aria-label="Main menu"
    )
        router-link.navItem(
            v-for="item in items"
            :key="item.title"
            :to="item.link"
        )
            img.mb-1(v-if="item.iconLink && isMember" :src="item.iconLink" :alt="item.iconAlt")
            v-icon.nav-icon.material-icons-outlined(v-if="item.icon && isMember") {{ item.icon }}
            div.menuTitle(v-if="item.title != 'general.menu.statistics'" v-t="item.title")
            div.menuTitle(v-if="item.title === 'general.menu.statistics'" v-t="'general.menu.stats'")
</template>

<script>
    import VueTypes from 'vue-types';
    import { mapGetters } from 'vuex';
    import { isIOS, isAndroid } from '~services';

    export default {
        props: {
            items: VueTypes.array.def()
        },
        computed: {
            ...mapGetters('auth', ['isMember']),

            /**
             * iOS home indicator is ~34 dp and sits inside a real gesture
             * swipe zone — overlapping it breaks the "swipe up to go home"
             * gesture, so the nav MUST clear the safe-area inset.
             * Android's gesture pill is ~4 dp tall on a ~24 dp strip and
             * is designed to overlay UI — keeping our nav flush with the
             * bottom edge lets the translucent bar sit over it, and the
             * pill remains visible via the OS's contrast handling.
             */
            platformClass() {
                if (isIOS()) return 'is-ios';
                if (isAndroid()) return 'is-android';
                return 'is-web';
            }
        }
    };
</script>

<style lang="stylus" scoped>
    @import "../../assets/style/_mixins.styl"
    @import "../../assets/style/_variables.styl";

    .mobileNavigation
        display: flex
        align-items: center
        justify-content: space-around
        position: fixed
        z-index: 5
        // Baseline for web / unknown platforms — overridden per-
        // platform below.
        bottom: 16px

        // iOS: sit closer to the bottom edge while still staying
        // clear of the home indicator's swipe zone (~34 dp).
        &.is-ios
            bottom: calc(env(safe-area-inset-bottom, 16px) - 16px)

        // Android: clear the gesture / 3-button navigation bar. Even
        // with MainActivity hiding the nav bar via WindowInsetsController,
        // Android 14/15 still reserves the gesture pill strip on many
        // devices and reports it via safe-area-inset-bottom. Use that
        // inset plus a small baseline so the menu never sits under the
        // system pill.
        &.is-android
            bottom: calc(env(safe-area-inset-bottom, 0px) + 8px)
        left: 12px
        right: 12px
        width: calc(100% - 24px)
        background: rgba(2, 35, 65, 0.92)
        backdrop-filter: blur(16px)
        -webkit-backdrop-filter: blur(16px)
        border-radius: 24px
        border: 1px solid rgba(255, 255, 255, 0.1)
        box-shadow: 0 8px 32px rgba(0, 0, 0, 0.45), 0 1px 0 rgba(255, 255, 255, 0.06) inset
        padding: 6px

        img
            height: 18px
            filter: brightness(0) invert(1)
            opacity: 0.4
            transition: opacity 0.25s

        .nav-icon
            font-size: 20px
            color: $theme.white
            opacity: 0.4
            transition: opacity 0.25s, font-size 0.25s

        a.navItem
            display: flex
            flex-direction: column
            align-items: center
            justify-content: center
            flex: 1
            padding: 8px 6px
            border-radius: 18px
            color: rgba(255, 255, 255, 0.4)
            text-decoration: none
            font-size: 10px
            font-weight: 400
            text-transform: capitalize
            transition: color 0.25s, background 0.25s

            &.router-link-active
                background: rgba(112, 150, 210, 0.18)
                color: $theme.white
                font-weight: 500

                .nav-icon
                    opacity: 1
                    font-size: 22px

                img
                    opacity: 1
</style>
